import Link from 'next/link';
import styled from 'styled-components';
import Typography from './common/Typography';
interface CategoryItemProps {
  id: number | string;
  iconUrl: string;
  name: string;
  description?: string;
  type: '마켓' | '체험' | '숙소';
}

const CategoryItem = ({ iconUrl, name, id, type }: CategoryItemProps) => {
  return (
    <ItemContainer href={type === '마켓' ? `/market/category/kind/${id}` : `/category/kind/${id}`}>
      <ImgWrapper>
        <img src={iconUrl ?? ''} alt={name} width={55} height={55} />
      </ImgWrapper>
      <Content>
        <Typography variant="b2" color="gray900">
          {name}
        </Typography>
      </Content>
    </ItemContainer>
  );
};

export default CategoryItem;

const ItemContainer = styled(Link)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3px;
  width: 84px;
  text-align: center;

  @media (max-width: 768px) {
    width: 100%;
    max-width: 68px;
    margin: 0 auto;
    gap: 4px;
  }
`;

const ImgWrapper = styled.div`
  padding: 7px;
  width: 76px;
  height: 76px;
  overflow: hidden;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  @media (max-width: 768px) {
    width: 56px;
    height: 56px;
    padding: 2px;

    img {
      object-fit: contain;
    }
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  @media (max-width: 768px) {
    p {
      font-size: 12px;
      line-height: 14px;
      white-space: nowrap;
    }
  }
`;
